<div>
  <app-remitos-lista></app-remitos-lista>
</div>